// Limitless imports
import { useGraphAPIHook } from "@limitless/portal";
import { useExpertOnboardingContext } from "../expert-onboarding/ExpertOnboardingContext";
import { UPDATE_CLIENT_CHECK } from "../../apis/onboarding-queries/UserOnboardingQueries";
export const useExpertChecksHook = (t = v => v) => {
  const {
    onboardingDetail,
    setOnboardingDetail
  } = useExpertOnboardingContext();
  const {
    mutateData
  } = useGraphAPIHook();
  const updateMemberDetails = result => {
    setOnboardingDetail({
      loading: false,
      onboarding: {
        ...onboardingDetail.onboarding,
        ...result.updateClientCheckValue
      },
      hasError: false
    });
  };
  const saveMemberDetails = check => {
    const {
      value,
      id
    } = check;
    const {
      tenantName,
      groupName
    } = onboardingDetail.onboarding;
    const options = {
      dataKey: updateMemberDetails,
      mutation: UPDATE_CLIENT_CHECK,
      variables: {
        value,
        id,
        tenantName,
        groupName
      },
      functionName: "saveMemberDetails",
      notifyDetails: {
        errorNotification: t("Failed to save value, please try again")
      }
    };
    mutateData(options);
  };
  return {
    saveMemberDetails
  };
};